// extracted by mini-css-extract-plugin
module.exports = {"select":"styles-module__select___3RYcj","wrapper":"styles-module__wrapper___38Mtx"};